import React from 'react';
import './PermissionRow.scss';
import { GetRolePermissions_getPermissionRoles_categories_permissions as PermissionRole } from '../../../../../types/schemaTypes';
import { uniqueId } from 'lodash';
import { useAuthContext } from '../../../../Auth/AuthProvider';
import { PermissionEnum } from '../../../../../types/PermissionEnum';
interface PermissionRowProps {
    permissionRole: PermissionRole;
    onChange: (roleId: number, permissionId: number, checkedStatus: boolean) => void;
}

const PermissionRow = ({ permissionRole, onChange }: PermissionRowProps): React.ReactElement => {
    const canEditPermissions = useAuthContext().userHasPermission(PermissionEnum.EditPermissions);
    return (
        <div className="PermissionRow-RowContainer">
            <div className="PermissionRow-RowName">{permissionRole.name}</div>
            <div className="PermissionRow-RowItem">
                {permissionRole.assignments.map(assignment => (
                    <div className="PermissionRow-CheckboxRow" key={assignment.roleId}>
                        <input
                            className="PermissionRow-Checkbox"
                            id={uniqueId()}
                            type="checkbox"
                            checked={assignment.isAssigned}
                            onChange={(event): void =>
                                onChange(assignment.roleId, permissionRole.id, event.currentTarget.checked)
                            }
                            disabled={!canEditPermissions}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PermissionRow;
